export const environment = {
  envName: 'dev',
  sentryIO: false,
  hmr: false,
  production: false,
  apiURL: 'https://back.devarea.app/mBase/',
  productsAPI: 'https://back.devarea.app/mbaseProductsManagement/',
  oauth: {
    host: 'back.devarea.app',
    https: true,
    client_id: 'mbasebackoffice',
    client_secret: 'Su4r3zUpl04dN0w'
  },
  communication: {
    https: true
  },
  filetransfer: {
    host: 'files.devarea.app',
    namespace: '/',
    path: '/upload'
  }
};
